const VIDEO_TYPE_MAP = {
    mp4: "video/mp4",
    webm: "video/webm"
};
export const getVideoType = (videoSrc) => {
    const extension = videoSrc.split(".").pop();
    return extension && VIDEO_TYPE_MAP[extension];
};
